var base = require('settings/teams/google-search-provider-settings');

Vue.component('spark-google-search-provider-settings', {
    mixins: [base]
});
